import { render } from "./PsychologistEvaluations.vue?vue&type=template&id=38e4cf2a"
import script from "./PsychologistEvaluations.vue?vue&type=script&lang=js"
export * from "./PsychologistEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__